import React from 'react';
import styled, { keyframes } from 'styled-components';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { PALETTE } from '~/assets/styles/base';

type WrapperProps = {
  $open: boolean;
};

const fadeIn = keyframes`
		from { opacity: 0; }
    to { opacity: 1; }
`;

const Wrapper = styled.div<WrapperProps>`
  width: 400px;
  height: 96px;
  display: ${({ $open }) => ($open ? 'flex' : 'none')};
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #2e7d32;
  position: fixed;
  top: 75px;
  right: 15px;
  background-color: ${PALETTE.white};
  animation-name: ${fadeIn};
  animation-duration: 2s;

  & > svg {
    font-size: 20px;
    position: absolute;
    top: 10px;
    left: 20px;
    color: #8795a5;
  }
`;

const GreenLine = styled.div`
  width: 8px;
  height: 100%;
  background-color: #2e7d32;
`;

const AlertContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 48px;
  width: 100%;

  p {
    text-align: left;
  }
`;

const AlertHeader = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  color: #2e7d32;

  svg {
    font-size: 24px;
  }

  span {
    margin-left: 10px;
  }
`;

type Props = {
  head: JSX.Element | string;
  body: JSX.Element | string;
  open: boolean;
  onClose: () => void;
};

const AlertSuccess: React.FC<Props> = ({ head, body, open, onClose }): JSX.Element => (
  <Wrapper $open={open} data-testid="uiParts-AlertSuccess">
    <ClearOutlinedIcon data-testid="close_alert_success" onClick={() => onClose()} />
    <GreenLine />
    <AlertContent>
      <AlertHeader>
        <TaskAltOutlinedIcon /> <span>{head}</span>
      </AlertHeader>
      <p>{body}</p>
    </AlertContent>
  </Wrapper>
);

export default AlertSuccess;
